import comp from "./SubjectEditModal";
export default comp;
